import { type JSX, Component, h, Host, Prop, State } from "@stencil/core";
import type { tagColor } from "../model-tags/model-tags";

@Component({
  tag: "phn-model-banner-tile",
  styleUrl: "model-tile.scss",
  scoped: true,
})
export class ModelBannerTile {
  @Prop() breakpoint!: number;

  @Prop() text!: string;

  @Prop() tags!: string[];

  @Prop() srcSet: string;

  @State() tagColor: tagColor = "black";

  @Prop() addGradient?: boolean;

  extract2xImage(srcSet: string): string {
    const images = srcSet.split(",").map((image) => image.trim());
    const image2x = images.find((image) => image.includes("2x"));
    return image2x ? image2x.replace(" 2x", "") : images[0];
  }

  render(): JSX.Element {
    const url = this.extract2xImage(this.srcSet);
    const tags = this.tags.map((text) => {
      return { text, icon: undefined };
    });

    return (
      <Host>
        <div
          class="model-area-button banner"
          style={{ backgroundImage: `url(${url})` }}
        >
          {this.addGradient && <div class="gradient-overlay"></div>}
          <div class="model-content">
            <phn-p-heading
              size="medium"
              tag="h3"
              dir="auto"
              color="inherit"
              style={{ color: "white" }}
            >
              {this.text}
            </phn-p-heading>
            <div class="model-tags">
              <phn-model-tags
                breakpoint={this.breakpoint}
                data-test-id="model-tags"
                tagColor={this.tagColor}
                modelTags={tags}
              />
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
